<template>
  <!--stateStorage="session"
    stateKey="dt-state-demo-session"-->
  <div>
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
@row-select="onRowSelect"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :first="firstRecordIndex"
    :scrollable="(scrollHeight !== '' ? true : false) "
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
    :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column
      v-for="c in model.getDisplayFields()"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="(c.class ? 'txt-' + c.class : '')"
      :bodyStyle="getBodyStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <!--{{c}}-->
        <img
          v-if="getType(c) == 'Image'"
          :src="getData(c, slotProps.data)"
          style="width: 40px; heigth: 40px"
        />
        <div v-else-if="c.key == 'want_to_exchange'" class="want-exchange-cell">
          <template v-if="slotProps.data.want_to_exchange_labels && slotProps.data.want_to_exchange_labels.length > 0">
            <div v-if="slotProps.data.want_to_exchange_first_option">
              <div><strong>Rule type:</strong> {{ slotProps.data.want_to_exchange_first_option.rule_type_label }}</div>
              <div
                v-for="(weekLabel, weekIndex) in slotProps.data.want_to_exchange_first_option.weeks"
                :key="`wk-line-${slotProps.data.id}-${weekIndex}`"
              >
                {{ weekLabel }}
              </div>
              <div v-if="slotProps.data.want_to_exchange_first_option.has_property_info">
                <strong>List of properties:</strong> {{ slotProps.data.want_to_exchange_first_option.properties_text }}
              </div>
            </div>
            <Button
              v-if="slotProps.data.want_to_exchange_labels.length > 0"
              class="p-button-link p-0"
              :label="getViewMoreLabel(slotProps.data.want_to_exchange_labels.length)"
              @click.stop="openWeekPopup(slotProps.data)"
            />
          </template>
        </div>
        <div
          v-else-if="c.type == 'Text'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomUrl' && view_club ==true"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="redirectListClub(slotProps.data, $event)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomUrl'"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="redirectListClub(slotProps.data, $event)"
          :style="(c.style ? c.style : '')"
        ></div>

        <Checkbox
          v-else-if="getType(c) == 'Checkbox'"
          v-model="slotProps.data[slotProps.column.field]"
          :binary="true"
          @change="onInputChange($event, slotProps.data, c)"
        />
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />
            <div v-if="c.custom == 'SelectionText'"  v-html="callbackDataSelect( c ,slotProps.data)"></div>
            <div v-if="c.custom == 'SelectionDropdown'">
              <Dropdown class="w-100" :disabled="disabledCustomDropdown(c, slotProps.data[c.key])" v-model="slotProps.data[c.key]" :options="c.dropdown.options" :optionLabel="c.dropdown.label" :optionValue="c.dropdown.value" @change="changeCustomDropdown(c, slotProps.data, slotProps.data[c.key])"/>
            </div>
          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>


      </template>
      <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
        />
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"

          @change="onFilter($event,c.filter.type,c.key)"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <Calendar
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearRange"
          dateFormat="MM dd, yy"
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter calendar-light-btn"
          :showIcon="true"
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          >
        
          <template #footer>
            <CalendarFooter />
          </template>
        </Calendar>
          
          <Calendar
          v-if="c.filter.type == 'Date'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearDOB"
          dateFormat="MM dd, yy"
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter calendar-light-btn"
          :showIcon="true"
          selectionMode="single"
          appendTo="body"
          :showClear="true"
          :maxDate="new Date()"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          />
      </template>
    </Column>
    <Column
      v-if="actions"
      headerStyle="width: 10em; text-align: center"
      bodyStyle="width: 10em; text-align: center; justify-content: center"
    >
      <template #body="slotProps">
        <div class="style-action-click">
          <Button
              v-for="(a, k) in actions.rows(slotProps.data)"
              :key="k"
              type="button"
              :icon="getIcon(a.icon)"
              :class="getClass(a.name)"
              :disabled="getDisabled(a.disabled)"
              style="margin: 2px"
              v-on:click="actionsClicked(k, a, slotProps)"
          ></Button>
        </div>
      </template>
      <template #header="slotProps">
        <Button
          v-if="actions.header"
          type="button"
          :icon="getIcon(actions.header.icon)"
          :class="getClass(actions.header.name)"
          v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
        <span v-else class="p-column-title">Actions</span>
      </template>
    </Column>
    <template #empty>
      {{ $t('datatable.empty') }}
    </template>
    <template #loading>
      {{ $t('datatable.loading') }}
    </template>
  </DataTable>
  <Dialog header="Exchange options" :visible.sync="showWeekPopup" :style="{width: '52vw'}">
    <div v-if="popupOptionDetails.length > 0" class="popup-week-list">
      <div v-for="(option, index) in popupOptionDetails" :key="`popup-option-${index}`" class="popup-option-card">
        <div><strong>Rule type:</strong> {{ option.rule_type_label }}</div>
        <div v-for="(weekLabel, weekIndex) in option.weeks" :key="`popup-wk-${index}-${weekIndex}`">{{ weekLabel }}</div>
        <div v-if="option.has_property_info" class="popup-property-line">
          <strong>List of properties:</strong>
          <div class="popup-property-chips">
            <button
              type="button"
              v-for="(propertyItem, propertyIndex) in option.popup_properties"
              :key="`popup-prop-${index}-${propertyIndex}`"
              class="popup-property-chip"
              @click="openPropertyEditInNewTab(propertyItem)"
            >
              {{ propertyItem.label }}
            </button>
            <span v-if="option.popup_properties.length < 1" class="popup-property-pending">
              Property info is updating...
            </span>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <Button label="Close" class="p-button-secondary" @click="showWeekPopup = false"/>
    </template>
  </Dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
//import gql from "graphql-tag";
import DataServices from "@/core/DataServices";
import ApiRepository from "@/core/ApiRepository";
export default {
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
    // view_club:Boolean ,
  },
  data() {
    return {
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '75vh', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService:null,
      filtersCustom: [],
      lazyParams: {},
      page_transaction:null,
      firstRecordIndex:0,
      yearRange : (new Date().getFullYear() - 100)+":"+(new Date().getFullYear() + 100),
      yearDOB : (new Date().getFullYear() - 100)+":"+new Date().getFullYear(),
      time_zone_local : moment.tz.guess(true),
      view_club : false,
      showWeekPopup: false,
      popupWeekLabels: [],
      popupOptionDetails: [],
      exchangeOptionLabelCache: {},
      exchangeOptionDetailCache: {},
    };
    
  },
  async created() {
    var year = new Date().getFullYear()
    var yearRange = (year-10)+':'+(year+90);
    var yearDOB = (year-100)+':'+year;
    this.yearRange = yearRange+'';
    this.yearDOB = yearDOB+'';
    this.test = this.tableData;
    var arr_role_clubs = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_AVAILABLE);
    // console.log('role_clubrole_club',arr_role_clubs)
    if (arr_role_clubs.indexOf(this.$constants.ROLE.VIEW) < 0){
      this.view_club = false;
    }else{
      this.view_club = true;
    }
  },
  mounted () {
    this.scrollHeight = `${(window.innerHeight*(window.innerHeight > 900 ? 70 : 55)/100)}px`;
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    /*
    * stateStorage="session"
    stateKey="dt-state-demo-session"
    * phai them thuoc tinh nay vao table
    * */
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        this.firstRecordIndex = this.lazyParams.first;
        // console.log("this.lazyParams:22222222",this.lazyParams);
        /*if (this.lazyParams){
          this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    onRowSelect(event) {
      this.$emit('onRowSelect', event.data);
    },
    getFilterDate(date) {
        return moment.tz(date, this.time_zone_local).format("LL");
    },
    getWeekLabel(startDate, endDate) {
      return `Week ${moment(startDate).isoWeek()} (${this.getFilterDate(startDate)} - ${this.getFilterDate(endDate)})`;
    },
    openWeekPopup(rowData = {}) {
      const details = this.exchangeOptionDetailCache[rowData?.id] || [];
      if (details.length > 0) {
        this.popupOptionDetails = details.map((opt) => ({ ...opt }));
      } else {
        const fallbackLabels = Array.isArray(rowData?.want_to_exchange_labels) ? rowData.want_to_exchange_labels : [];
        this.popupOptionDetails = fallbackLabels.map((label) => ({
          rule_type_label: "My own property",
          weeks: [label],
          has_property_info: false,
          popup_properties: [],
        }));
      }
      this.showWeekPopup = true;
    },
    getRuleTypeLabel(typeRule) {
      const map = {
        1: "My own property",
        2: "A specific property",
        3: "Any property",
      };
      return map[parseInt(typeRule || 3)] || "Any property";
    },
    getWeekLabelByMs(startMs, endMs) {
      if (!startMs || !endMs) return "";
      return this.getWeekLabel(new Date(parseInt(startMs)), new Date(parseInt(endMs)));
    },
    getViewMoreLabel(totalOptions = 0) {
      const moreCount = Math.max(parseInt(totalOptions || 0) - 1, 0);
      if (moreCount < 1) return "View more";
      return `View more (${moreCount} item${moreCount > 1 ? "s" : ""})`;
    },
    buildExchangeOptionDetail(option = {}) {
      const weekLabels = (option?.weeks || [])
        .map((w) => this.getWeekLabelByMs(w?.visit_start_mi, w?.visit_end_mi))
        .filter(Boolean);
      const propertyItems = (option?.list_property || [])
        .map((p) => {
          const label = `${p?.code ? `${p.code} - ` : ""}${p?.name || ""}`.trim();
          if (!label) return null;
          return {
            id: p?.id || null,
            label: label,
          };
        })
        .filter(Boolean);
      const propertyNames = propertyItems.map((p) => p.label);
      const propertyIds = Array.isArray(option?.property_ids) ? option.property_ids.filter(Boolean) : [];
      const hasPropertyInfo = propertyNames.length > 0 || propertyIds.length > 0;
      const selectedCount = propertyIds.length > 0 ? propertyIds.length : propertyNames.length;
      const propertiesText = selectedCount > 0
        ? `${selectedCount} selected`
        : "";
      const popupProperties = propertyItems.length > 0 ? propertyItems : [];
      return {
        rule_type_label: this.getRuleTypeLabel(option?.type_rule),
        weeks: weekLabels,
        properties: propertyNames,
        property_ids: propertyIds,
        has_property_info: hasPropertyInfo,
        properties_text: propertiesText,
        popup_properties: popupProperties,
      };
    },
    openPropertyEditInNewTab(propertyItem = {}) {
      if (!propertyItem?.id) return;
      const routeData = this.$router.resolve({
        path: `/admin/list-property/edit/${propertyItem.id}`,
        query: { page_transaction: (new Date()).getTime().toString() },
      });
      window.open(routeData.href, "_blank");
    },
    buildExchangeOptionLabel(option = {}, index = 0) {
      const ruleLabel = this.getRuleTypeLabel(option?.type_rule);
      const weekLabels = (option?.weeks || [])
        .map((w) => this.getWeekLabelByMs(w?.visit_start_mi, w?.visit_end_mi))
        .filter(Boolean);
      const propertyNames = (option?.list_property || [])
        .map((p) => `${p?.code ? `${p.code} - ` : ""}${p?.name || ""}`.trim())
        .filter(Boolean);
      const parts = [`Option ${index + 1} (${ruleLabel})`];
      if (weekLabels.length > 0) {
        parts.push(`Weeks: ${weekLabels.join(" | ")}`);
      }
      if (propertyNames.length > 0) {
        parts.push(`Properties: ${propertyNames.join(", ")}`);
      }
      return parts.join(" | ");
    },
    async getExchangeOptionsBatch(availableIds = []) {
      const ids = Array.isArray(availableIds) ? availableIds.filter(Boolean) : [];
      if (ids.length < 1) return;
      try {
        const headers = {
          Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
        };
        const res = await ApiRepository.post(
          "/_api/property/list_exchange_options_batch",
          { available_ids: ids },
          { headers }
        );
        const data = res?.data?.data ?? res?.data ?? {};
        ids.forEach((availableId) => {
          const options = Array.isArray(data?.[availableId]) ? data[availableId] : [];
          const details = options.map((opt) => this.buildExchangeOptionDetail(opt));
          const labels = options
            .map((opt, idx) => this.buildExchangeOptionLabel(opt, idx))
            .filter(Boolean);
          this.exchangeOptionDetailCache[availableId] = details;
          this.exchangeOptionLabelCache[availableId] = labels;
        });
      } catch (e) {
        ids.forEach((availableId) => {
          this.exchangeOptionDetailCache[availableId] = [];
          this.exchangeOptionLabelCache[availableId] = [];
        });
      }
    },
    redirectListClub(data, e) {
      let clickedElId = e.target.id
      var path = ``;
      var id = data.id;
      if (clickedElId === 'list-owner') {
        id = data?.create_user?.id;
        path = `/admin/list-users/edit/${id}`;
      } else if (clickedElId === 'list-property') {
        id = data?.property?.id;
        path = `/admin/list-property/edit/${id}`;
      }
      this.$router.push({path: path, query: { page_transaction: (new Date()).getTime().toString() }});
      e.stopPropagation();
    },
    callbackCustomUrl(c,data){
      var text = ''
      switch(c.key) {
        case 'owner_name':
          text = '<a class="txt-link" id="list-owner" :data-id="'+data?.create_user?.id+'">'+data?.create_user?.fullname+'</a>';
          break;
        case 'property_code':
          text = '<a class="txt-link" id="list-property" :data-id="'+data?.property?.id+'">'+data?.property?.code+'</a>';
          break;
        case 'property_name':
          text = '<a class="txt-link" id="list-property" :data-id="'+data?.property?.id+'">'+data?.property?.name+'</a>';
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "text-align:center;";
      if (col.width) style += "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style += "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style += "width: 6em;";
      else style += "min-width: 10em;";
      return style;
    },
    getBodyStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "text-align:center; width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      else style += "min-width: 10em;";
      return style;
    },
    getData(col, row) {
      // console.log("this.options:",this.options)
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("LL");
        // value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("ll HH:mm");
        // value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          // console.log("col.models:",col.models);
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        else if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        else if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        else {
          value = row[col.key];
        }
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn`;
      } else if (col.filter.type == "input") {
        return `Input`;
      } else if (col.filter.type == "DateRange") {
        return `Choose`;
      } else if (col.filter.type == "Date") {
        return `Choose`;
      } else {
        return ``;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams:this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "EUR"
      });
    },
    disabledCustomDropdown(c, data) {
      var disabled = false;
      switch(c.key) {
        case 'status': 
          disabled = data != 'ST001';
          break;
      }
      return disabled;
    },
    async changeCustomDropdown(c, data, value) {
      if(c.key == 'status') {
        let variables = {
          'data_update': {status: value, updated_at: moment.tz(new Date(), this.time_zone_local), updated_by: this.$store.getters.user},
          'where_key': {
            'id': {'_eq': data?.id}
          }
        }
        await this.$apollo.mutate({
            mutation: DataServices.updateData('visit_order_item'),
            variables: variables
        }).then(() => {
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Update data successfully', life: 3000 })
          this.onLazyEvent();
        });
      }
    },
    callbackDataSelect(c,data){
        var text = "";
        switch(c.key) {
            case 'updated_name':
                text = data?.update_user?.fullname;
                break;
            case 'my_property':
              if (data?.my_property) {
                  text += '<div style="text-align: center;"><i class="fa fa-solid fa-check" style="color: #00973D;"/></div>';
                }else{
                  text += '<div style="text-align: center;"><i class="fa fa-solid fa-times" style="color: #E95D57;"/></div>';
                }
                break;
            case 'active':
                if (data?.active) {
                  text += '<div style="text-align: center;"><i class="fa fa-solid fa-check" style="color: #00973D;"/></div>';
                }else{
                  text += '<div style="text-align: center;"><i class="fa fa-solid fa-times" style="color: #E95D57;"/></div>';
                }
                break;
            case 'status':
                var list = [
                    {
                        value: 'ST001',
                        label: 'request'
                    },
                    {
                        value: 'ST002',
                        label: 'accepted'
                    },
                    {
                        value: 'ST003',
                        label: 'Cancelled'
                    },
                ];
                var textS = list.filter(f => f.value == data?.status)[0]?.label;
                var textT = [{value: 2, label: 'Exchange'}, {value: 3, label: 'Rent'}].filter(f => f.value == data?.type)[0]?.label;
                if (data?.status != 'ST003') {
                  text += `${textT} ${textS}`;
                } else {
                  text += textS;
                }
                break;
            case 'name_sports':
                if(data.users_setting_sports && data.users_setting_sports.length > 0){
                    for (var i=0;i<data.users_setting_sports.length;i++){
                        let tm = data.users_setting_sports[i];
                        if(tm.sports){
                            if(text.length > 60){
                              text += ",...";
                              break;
                            }
                            if(tm.sports.sports_lang.length > 0){
                                for (let j = 0; j < tm.sports.sports_lang.length; j++) {
                                    let el = tm.sports.sports_lang[j];
                                    if(el.lang =='en'){
                                        text += (!this.$commonFuction.isEmpty(text)) ?  ", "+el.name:el.name;
                                        break;
                                    }
                                } 
                            }
                        }
                    }
                }
                break;
            default:
        }
        return text;
    },
   async dataList(lazyParams) {
    // console.log('lazyParams');
    // console.log('lazyParams:',lazyParams);
     var offset = lazyParams.first;
     var limit = lazyParams.rows;
     var gqLQueryList = DataServices.getList(this.model.tableName);
     var where = {
       deleted: {_eq: false},
       _and: []
     }
     var filters = lazyParams.filters;
     if (filters){
       for (const [key, value] of Object.entries(filters)) {
        //  console.log("dsadsd",value.type_input);
          if (value.type_input == 'input'){
            if (!this.$commonFuction.isEmpty(value.value)){
             if (key == 'property_code'){
                if(!where.property){
                  where.property = {};
                }
                where.property.code ={_iregex: this.$commonFuction.search(value.value)} 
              } 
              else if (key == 'property_name'){
                if(!where.property){
                  where.property = {};
                }
                where.property.name ={_iregex: this.$commonFuction.search(value.value)} 
              } else if (key == 'owner_name'){
                where.create_user = {fullname: {_iregex: this.$commonFuction.search(value.value)}};
              } else if (key == 'request_code'){
                where.request += {code: {_iregex: this.$commonFuction.search(value.value)}};
              } else if (key == 'order_code'){
                where.order_item = {order: {code: {_iregex: this.$commonFuction.search(value.value)}}};
              } else if (key == 'booked'){
                where.created = {fullname: {_iregex: this.$commonFuction.search(value.value)}};
              } else if (key == 'assign_name'){
                where.assign = {fullname: {_iregex: this.$commonFuction.search(value.value)}};
              } else if (key == 'service_name'){
                where.service = {name: {_iregex: this.$commonFuction.search(value.value)}};
              } else {
                where[key] = {_iregex: this.$commonFuction.search(value.value)};
              }
            }
          }
         else if(value.type_input == 'select'){
            // console.log("filters",filters)
            if(key == "updated_name"){
                if(value.value !== undefined && value.value !== null){
                    where['updated_by'] = {_eq: value.value}
                }
            }else{
                if(value.value !== undefined && value.value !== null){
                    where[key] = {_eq: value.value}
                }
            }
          }else if (value.type_input == 'DateRange'){
            if(value.value !== undefined && value.value !== null){
              if (key == 'arrival') {
                where.reuqest += {visit: {arrival: {'_gte': value.value.from, '_lte': value.value.to}}}
              } else if (key == 'visit_week') {
                // where.visit = {visit_start: {'_gte': value.value.from, '_lte': value.value.to}}
                where.visit = {_or: [{visit_end: {'_gte': value.value.to}, visit_start: {'_lte': value.value.from}}, {visit_start: {'_gte': value.value.from}, visit_end: {'_lte': value.value.to}}]};
              } else {
                where[key] = {'_gte': value.value.from,'_lte': value.value.to}
              }
            }
          } else if (value.type_input == 'Date'){
              if(value.value !== undefined && value.value !== null){
                // console.log("dsadasdas");
                if(key == "full_birthday"){
                  where[key] = {_eq: moment(value.value).tz("Asia/Ho_Chi_Minh").format("yyyy-MM-DD")}
                } else {
                  where[key] = {_eq: value.value}
                }
              }

          }
       }

     }
     var resData = await this.$apollo.mutate({
       mutation: gqLQueryList,
       variables: {
         where_key:where ,
         offset:offset,
         limit:limit,
         orderBy:{created_at: 'desc'}
       }
     });
     var listData = resData.data[this.model.tableName];

     var gqLQueryCount = DataServices.countData(this.model.tableName);
     var countRes = await this.$apollo.mutate({
       mutation: gqLQueryCount,
       variables: {
         where_key:where
       }
     });
     var total = countRes.data[this.model.tableName+'_aggregate']['aggregate']['count'];

     var dataRes = {
       listData: listData,
       total: total,
     };
    //  console.log('dataRes:',dataRes);
     return dataRes;
    },
    onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      this.exchangeOptionLabelCache = {};
      this.exchangeOptionDetailCache = {};
      // console.log('this.lazyParams:',this.lazyParams)
      this.loading = true;
      var that =this;
      this.dataList(this.lazyParams).then(async data => {
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        const exchangeIds = data.listData
          .filter((item) => parseInt(item?.type || 0) === 2 && item?.id)
          .map((item) => item.id);
        await this.getExchangeOptionsBatch(exchangeIds);
        var stt = this.lazyParams.first ?? 0;
        for (var i = 0; i < data.listData.length; i++) {
          stt++;
          data.listData[i].stt = stt;
          data.listData[i].property_code = data.listData[i]?.property?.code || null;
          data.listData[i].property_name = data.listData[i]?.property?.name || null;
          data.listData[i].owner_name = data.listData[i]?.create_user?.fullname || null;
          data.listData[i].updated_name = data.listData[i]?.update_user?.fullname;
          data.listData[i].visit_week = `Week ${data.listData[i]?.visit?.week_number} (${this.getFilterDate(data.listData[i]?.visit?.visit_start)} - ${this.getFilterDate(data.listData[i]?.visit?.visit_end)})`;
          let weekLabels = [];
          let firstOption = null;
          if (parseInt(data.listData[i]?.type || 0) === 2) {
            weekLabels = this.exchangeOptionLabelCache[data.listData[i]?.id] || [];
            firstOption = (this.exchangeOptionDetailCache[data.listData[i]?.id] || [])[0] || null;
            if (weekLabels.length < 1 && data.listData[i]?.week) {
              data.listData[i].week.map(m => {
                weekLabels.push(this.getWeekLabel(m.visit_start, m.visit_end));
              });
            }
            if (!firstOption && data.listData[i]?.week) {
              firstOption = {
                rule_type_label: "My own property",
                weeks: data.listData[i].week.map((m) => this.getWeekLabel(m.visit_start, m.visit_end)),
                properties: [],
                property_ids: [],
                has_property_info: false,
                properties_text: "",
              };
            }
          } else if (data.listData[i]?.week) {
            data.listData[i].week.map(m => {
              weekLabels.push(this.getWeekLabel(m.visit_start, m.visit_end));
            })
          }
          data.listData[i].want_to_exchange_first_option = firstOption;
          data.listData[i].want_to_exchange_labels = weekLabels;
          data.listData[i].want_to_exchange = weekLabels.join(", ");
        }
        // console.log(data.listData)
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event,type_input,key){
      this.tableData = this.test;
      if(type_input == "DateRange"){
        if(this.filters[key] !== null && this.filters[key][1]== null){
          return false;
        }
      }
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input,key,this.filters);
      this.lazyParams.first = 0;
      this.onLazyEvent()
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom{padding: 0 !important;}
.p-inputtext{
  width: 100%;
}
.p-button-label{
  color : white;
}
.want-exchange-cell{
  text-align: left;
}
.want-exchange-cell .p-button.p-button-link{
  justify-content: flex-start;
  color: #1D76BC !important;
  opacity: 1 !important;
}
.want-exchange-cell .p-button.p-button-link .p-button-label{
  color: #1D76BC !important;
  text-decoration: underline;
}
.popup-week-list{
  max-height: 60vh;
  overflow-y: auto;
  line-height: 1.8;
}
.popup-option-card{
  border: 1px solid #d9dfe7;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
  background: #fff;
}
.popup-property-line{
  margin-top: 6px;
}
.popup-property-chips{
  margin-top: 4px;
}
.popup-property-chip{
  display: inline-block;
  margin-right: 6px;
  margin-bottom: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  background: #edf4fd;
  border: 1px solid #c9dcf6;
  font-size: 12px;
  line-height: 1.4;
  color: #325d8b;
  cursor: pointer;
}
.popup-property-chip:hover{
  background: #dcecff;
  border-color: #9cc0ea;
}
.popup-property-pending{
  font-size: 12px;
  color: #7a8899;
}
</style>
